import { useEffect, useState } from 'react';
import { fetchCached, resolveImageUrl } from '@/lib/api';

const LOGO_FALLBACK = '/logo.png';
const DEFAULT_FILTER = 'saturate(0.92) contrast(1.04)';

export default function SectionWatermark({
  as: Tag = 'section',
  children,
  className = '',
  contentClassName = '',
  watermarkClassName = '',
  opacity = 0.12,
  filter = DEFAULT_FILTER,
  ...props
}) {
  const [logoUrl, setLogoUrl] = useState(LOGO_FALLBACK);

  useEffect(() => {
    let mounted = true;
    fetchCached('/content/site_settings')
      .then((settings) => {
        if (!mounted) return;
        setLogoUrl(settings?.logo_url ? resolveImageUrl(settings.logo_url) : LOGO_FALLBACK);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Tag className={`relative isolate overflow-hidden ${className}`} {...props}>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center p-8 md:p-12"
      >
        <img
          src={logoUrl}
          alt=""
          className={`mscm-watermark-logo h-auto w-[min(78vw,34rem)] max-h-[82%] object-contain object-center select-none ${watermarkClassName}`}
          style={{ opacity, filter }}
          loading="lazy"
          decoding="async"
          draggable="false"
          onError={(e) => { e.currentTarget.src = LOGO_FALLBACK; }}
        />
      </div>
      <div className={`relative z-10 ${contentClassName}`}>
        {children}
      </div>
    </Tag>
  );
}
